/**
 * Feature Flags
 * @environment PERF / QA
 * @description These should be treated as you want the feature either on or off. These will completely override any A/B testing window variables if set to TRUE.
 * These should only be set to true when product or we decide the feature should be enabled for 100% of traffic. Be sure to also find out which brands a particular feature should be enabled for as this is brand specific.
 */

const featureFlags = {
  sameDayDeliveryEnabled: {
    dsg: true,
    gg: true,
    pl: false,
    mj: false,
    g3: false,
  },
  quickviewBoplEnabled: {
    dsg: true,
    gg: false,
    pl: false,
    mj: false,
    g3: false,
  },
  quickviewAutoSelectEnabled: {
    dsg: false,
    gg: false,
    pl: false,
    g3: false,
  },
  redirectToOtherVerticals: {
    dsg: false,
    gg: false,
    pl: false,
    mj: false,
    g3: false,
  },
  shorterDelaySAYTEnabled: {
    dsg: true,
    gg: false,
    pl: false,
    mj: false,
    g3: false,
  },
  featureNavOnTop: {
    dsg: false,
    gg: false,
    pl: false,
    mj: false,
    g3: false,
  },
  saytCategoriesRouteChangeEnabled: {
    dsg: true,
    gg: true,
    pl: true,
    mj: true,
    g3: true,
  },
  saytV2Enabled: {
    dsg: false,
    gg: false,
    pl: false,
    mj: false,
    g3: false,
  },
  preSaytEnabled: {
    dsg: false,
    gg: false,
    pl: false,
    mj: false,
    g3: false,
  },
  progressiveHeader: {
    dsg: false,
    gg: false,
    pl: false,
    mj: false,
    g3: false,
  },
  progressiveTaxoDesktop: {
    dsg: false,
    gg: false,
    pl: false,
    g3: false,
  },
  addFavoritesEnabled: {
    dsg: true,
    gg: true,
    pl: true,
    mj: true,
    g3: false,
  },
  skuFavoritesEnabled: {
    dsg: true,
    gg: true,
    pl: true,
    mj: true,
    g3: false,
  },
  trendingSearchBarEnabled: {
    dsg: false,
    gg: false,
    pl: false,
    mj: false,
    g3: false,
  },
  myAccountDrawer: {
    dsg: false,
    gg: false,
    pl: false,
    mj: false,
    g3: false,
  },
  hideUtilityBar: {
    dsg: false,
    gg: false,
    pl: false,
    mj: false,
    g3: false,
  },
  stickyHeader: {
    dsg: false,
    gg: false,
    pl: false,
    mj: false,
    g3: false,
  },
  PNBackTrackingEnabled: {
    dsg: false,
    gg: false,
    pl: false,
    mj: false,
    g3: false,
  },
  listPanelEnabled: {
    dsg: true,
    gg: true,
    pl: true,
    mj: true,
    g3: true,
  },
  showBrandSuggestionsInSayt: {
    dsg: false,
    gg: false,
    pl: false,
    mj: false,
    g3: false,
  },
  showCategorySuggestionsInSayt: {
    dsg: false,
    gg: false,
    pl: false,
    mj: false,
    g3: false,
  },
  showMenuPopover: {
    dsg: false,
    gg: false,
    pl: false,
    mj: false,
    g3: false,
  },
  smsSignUpEnabled: {
    dsg: false,
    gg: false,
    pl: false,
    mj: false,
    g3: false,
  },
  disableTrendingSearchBarOnHomePage: {
    dsg: false,
    gg: false,
    pl: false,
    mj: false,
    g3: false,
  },
  allCategories: {
    dsg: false,
    gg: false,
    pl: false,
    mj: false,
    g3: false,
  },
  consolidatedNavL0Links: {
    dsg: false,
    gg: false,
    pl: false,
    mj: false,
    g3: false,
  },
  consolidatedNavL0LinkToClp: {
    dsg: false,
    gg: false,
    pl: false,
    mj: false,
    g3: false,
  },
  trendingSearchInConsolidatedNav: {
    dsg: false,
    gg: false,
    pl: false,
    mj: false,
    g3: false,
  },
  shareListEnabled: {
    dsg: true,
    gg: true,
    pl: true,
    g3: false,
    mj: false,
  },
  headerLogoNetStorageEnabled: {
    dsg: true,
    gg: true,
    pl: true,
    mj: false,
    g3: true,
    plf: true,
  },
  expandableTicker: {
    dsg: false,
    gg: false,
    pl: false,
    mj: false,
    g3: false,
  },
  quickViewDrawerEnabled: {
    dsg: false,
    gg: false,
    pl: false,
    mj: false,
    g3: false,
  },
  logToServerDisabled: {
    dsg: false,
    gg: true,
    pl: true,
    mj: true,
    g3: true,
  },
  mobileOnlyProgressiveTaxo: {
    dsg: true,
    gg: true,
    pl: true,
    mj: false,
    g3: false,
  },
  QVproductNotAvailableImprovements: {
    dsg: false,
    gg: false,
    pl: false,
    mj: false,
    g3: false,
  },
  saytRedesignEnabled: {
    dsg: false,
    gg: false,
    pl: false,
    mj: false,
    g3: false,
  },
  preSaytRedesignEnabled: {
    dsg: false,
    gg: false,
    pl: false,
    mj: false,
    g3: false,
  },
  nikeConnectedEnabled: {
    dsg: false,
    gg: false,
    pl: false,
    g3: false,
  },
  devOnly_disableServerDataFetching: {
    dsg: false,
    gg: false,
    pl: false,
    g3: false,
    sm: false,
    plf: false,
  },
  devOnly_disableClientHomrFetching: {
    dsg: false,
    gg: false,
    pl: false,
    g3: false,
    sm: false,
    plf: false,
  },
  personalization_trendingSearches: {
    dsg: true,
    gg: false,
    pl: false,
    g3: false,
    sm: false,
    plf: false,
  },
  hideTicker: {
    dsg: false,
    gg: false,
    pl: false,
    mj: false,
    g3: false,
  },
};

export default featureFlags;
